// Use container.current size hook to determine if we should show the slider or not

// Path: src/hooks/useWindowSize.tsx

import React, {useCallback, useEffect, useState} from "react";

interface WindowSize {
    width: number | undefined;
    height: number | undefined;
}

const WIDTH_THRESHOLD = 600;

type Props = React.MutableRefObject<HTMLDivElement | null>;


const useContainerSize = (container: Props) => {
    const [containerSize, setContainerSize] = useState<WindowSize>({
        width: undefined,
        height: undefined,
    });
    const [isSmall, setIsSmall] = useState(false);

    const handleResize = useCallback(() => {
        setContainerSize({
            width: container.current ? container.current.offsetWidth : 0,
            height: container.current ? container.current.offsetHeight : 0,
        });
        setIsSmall(container.current ? container.current.offsetWidth <= WIDTH_THRESHOLD : false);
    }, [container]);

    useEffect(() => {
        const container_current = container.current;

        if(container_current) {
            container_current.addEventListener("resize", handleResize);

            handleResize();

            return () => container_current.removeEventListener("resize", handleResize);
        }
    }, [container, handleResize]);

    return {...containerSize, isSmall};
};

export default useContainerSize;